module.exports = __webpack_public_path__ + "img/house.7655ea87.png";